export function GeoPanel({ label, className = "" }) {
  return (
    <div className={`relative bg-ivory border border-champagne/40 flex items-center justify-center text-center px-6 ${className}`}>
      {label && (
        <span className="font-serif italic text-espresso/70" style={{ fontSize: "clamp(1.1rem,2.2vw,1.6rem)" }}>{label}</span>
      )}
    </div>
  );
}
